<template>
    <div>        
        <TextField v-model="user.email" inputClass="form-input" :title="$t('Email')" :disabled="true"/>
        <p class="title mt-3">{{ $t('Role') }}</p>
        <select v-model="selectedRole" class="form-input mb-3" style="border-radius: 5px;">
         <option :value="null"></option>
         <option v-for="role in roles" v-bind:value="role">
          {{ role.name }}
         </option>
        </select>
        <div class="row d-flex justify-content-between pb-5 mt-4">
            <div class="col flex-grow pr-1">
                <Button title="Cancel" buttonClass='cancel-button semi-bold w-100' @onClick="cancel"/>
            </div>
            <div class="col flex-grow pl-1">
                <Button title="Save" buttonClass='save-button semi-bold w-100' @onClick="save"/>
            </div>
        </div>
    </div>
</template>

<script>
    import TextField from '@/components/TextField'
    import Button from '@/components/Button'
    import { getRoles, getUserById, updateUserRole, removeUserRoles } from '@api'

export default {
    props: ['id'],
    watch: {},
    methods: {
        getData: async function() {
            this.roles = await getRoles();
            this.user = await getUserById(this.id);
            if(this.user.roles.length != 0) {
                this.selectedRole = this.roles.find(m => m.name === this.user.roles[0])
            }
        },
        cancel() {
            this.$emit('cancel');
        },
        async save() {
            if(this.selectedRole == null) {
                await removeUserRoles(this.id)
            } else {
                await updateUserRole(this.id, this.selectedRole.name)
            }

            this.$emit('save');
        }
    },
    computed: {
        farmId() {
        }
    },
    components: {
        Button,
        TextField,
    },
    mounted: function () {
        this.getData();
    },
    data: function() {
        return {
            user: {},
            roles: [],
            selectedRole: null
        }
    }
}

</script>

<style scoped>
select {
    padding-left: 0.5rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Users/EditUserRole.vue